import { render, staticRenderFns } from "./businessTab.vue?vue&type=template&id=44f422e7&scoped=true&"
import script from "./businessTab.vue?vue&type=script&lang=js&"
export * from "./businessTab.vue?vue&type=script&lang=js&"
import style0 from "./businessTab.vue?vue&type=style&index=0&id=44f422e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f422e7",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QList,QExpansionItem,QSeparator,QInput,QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QList,QExpansionItem,QSeparator,QInput,QToggle})
